"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var result = function (obj, propName) {
  if (obj === void 0) {
    obj = {};
  }

  if (propName === void 0) {
    propName = '';
  }

  var prop = obj[propName];

  if (typeof prop === 'function') {
    return prop.call(obj);
  }

  return prop;
};

var _default = result;
exports.default = _default;